import { ReactElement } from 'react';
import cc from 'classcat';
import {
  Button as ButtonComponent,
  ButtonProps,
  ButtonType
} from 'x-ui-design';
import { createTestId } from 'utils/helpers/create-test-id';
import { ButtonPropsType } from 'interfaces/button';
import './index.less';

export type TButtonProps = Omit<ButtonProps, 'type'> & {
  fullwidth?: boolean;
  customSize?: 'small' | 'medium' | 'large' | 'x-large';
  type?: ButtonPropsType;
};

export const Button = ({
  fullwidth,
  type = 'default',
  customSize,
  ...props
}: TButtonProps): ReactElement => {
  return (
    <ButtonComponent
      {...props}
      {...(!['green', 'cancel', 'fun'].includes(type) && {
        type: type as ButtonType
      })}
      data-testid="x-button-test-id"
      className={cc([
        `${customSize ? `xButton__${customSize}` : ''} x-button`,
        {
          'x-button--green': type === 'green',
          'x-button--cancel': type === 'cancel',
          'x-button--fun': type === 'fun',
          'x-button--link-primary': type === 'linkPrimary',
          'x-button--additional': type === 'additional',
          'x-button--fullWidth': fullwidth,
          'x-button--disabled': props.disabled
        },
        props.className
      ])}
      {...createTestId('x-button')}
    >
      {props.children}
    </ButtonComponent>
  );
};
